import { z } from "zod";
import { MetaSchema } from "./shared";

export const UserInfoSchema = z.object({
  id: z.string().uuid(),
  uuid: z.string(),
  isActivePlan: z.boolean(),

  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  gender: z.string().nullable(),

  rank: z.string().optional().nullable(),
  avatar: z.string().optional().nullable(),

  activatedPlanAt: z.string().datetime().optional().nullable(),
  createdAt: z.string().datetime(),
  deletedAt: z.string().nullable(),
});

const UsersInfoResponse = z.object({
  data: UserInfoSchema,
  meta: MetaSchema.default,
});

export type UsersInfoResponseType = z.infer<typeof UsersInfoResponse>;

export default UsersInfoResponse;
